import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { getVigboUrl } from 'reactApp/modules/vigbo/vigbo.helpers';
import { getVigboLinkState } from 'reactApp/modules/vigbo/vigbo.selectors';
import { openSubscribedToVigboModal } from 'reactApp/modules/vigbo/vigbo.toolkit';
import { VigboAccountLinkState } from 'reactApp/modules/vigbo/vigbo.types';
import { store as reduxStore } from 'reactApp/store';
import opener from 'reactApp/utils/opener';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { put } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';

const PROMO_ID = 'vigbo-buy-modal';

export function* initVigboSuccessBuyModal() {
    const { action } = getQueryParams();
    const vigboLinkState = yield* select(getVigboLinkState);
    const promoAlreadyShown: boolean = storeHelper.getValue(PROMO_ID);

    if (!action || action !== 'new-vigbo-tariff-success' || promoAlreadyShown || vigboLinkState === VigboAccountLinkState.linked) {
        return;
    }

    const email = yield* select(UserSelectors.getEmail);

    yield put(
        addPromoToShowQueue({
            type: EPromoType.showVigboBuyModal,
            promoId: PROMO_ID,
            onShow: () => {
                storeHelper.markAsShown(PROMO_ID);
                reduxStore.dispatch(promoShown(EPromoType.showVigboBuyModal));
                sendPaymentGa({
                    eventCategory: ECategoryGa.vigbo,
                    action: 'show-modal-start-vigbo-sub',
                });
            },

            onClick: () => {
                const linkAccounts = getVigboUrl('linkAccounts', { email });
                if (linkAccounts) {
                    opener(linkAccounts);
                }
                sendPaymentGa({
                    eventCategory: ECategoryGa.vigbo,
                    action: 'click-modal-start-vigbo-sub',
                });
            },

            onClose: () => {
                reduxStore.dispatch(removePromo(EPromoType.showVigboBuyModal));
            },
        })
    );
}

export function* showVigboSuccessBuyModal() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.showVigboBuyModal));

    if (!promo) {
        return;
    }

    yield call(openSubscribedToVigboModal, promo);
}
